// 模板配置基础数据
const CONFIG = {
    main_video: {
        label: "主图视频",
        key: "main_video",
        value: 4,
        options: [
            {
                value: 3,
                label: "上传由主图生成的轮播视频",
            },
            {
                value: 4,
                label: "上传来源链接的主图视频，若无视频则上传由主图生成的轮播视频",
            }
        ],
    },
    white_background_image: {
        label: "白底图",
        key: "white_background_image",
        value: 1, //0关闭 1抖店免费(上限后收费兜底) 2收费转白底图
        sub_value: 1,
        // 1第一张 3第二张 4第三张 5第四张 2最后一张（2保留兼容老模板）
        sub_options: [
            {
                value: 1,
                label: "第一张",
            },
            {
                value: 3,
                label: "第二张",
            },
            {
                value: 4,
                label: "第三张",
            },
            {
                value: 5,
                label: "第四张",
            },
            {
                value: 2,
                label: "最后一张",
            },
        ],
    },
    //安装设置
    anzhuang_settings: {
        label: "安装设置",
        key: "anzhuang_settings",
        value: 0, //0.不设置 1.选择平台合作服务商 2.线下提供免费上门安装 3.不提供上门安装
        options: [
            {
                value: 0,
                label: "不设置",
            },
            {
                value: 1,
                label: "选择平台合作服务商",
            },
            {
                value: 2,
                label: "线下提供免费上门安装",
            },
            {
                value: 3,
                label: "不提供上门安装",
            },
        ],
    },
    api_limit: {
        label: "接口限制后",
        key: "api_limit",
        value: 1,
        options: [
            {
                value: 1,
                label: "停止任务",
            },
            // {
            //     value: 2,
            //     label: "继续运行(注意高级解析时会持续扣费,慎用)",
            // }
        ]
    },
    listing_settings: {
        label: "上架设置",
        key: "listing_settings",
        value: 2,
        options: [
            {
                value: 1,
                label: "上架",
            },
            {
                value: 2,
                label: "下架",
            },
            {
                value: 3,
                label: "保存草稿",
            },
            // {
            //     value: 4,
            //     label: "先上草稿箱后上架",
            // },
        ],
    },
    daily_success_limit: {
        label: "每日商品复制成功",
        key: "daily_success_limit",
        value: false,
        sub_value: 500,
        ques: "勾选并设置数量后，只在铺货上架起作用，单个店铺（区分抖店/微小店）当日商品复制成功达到该数量时自动暂停该店铺任务。数量设为0表示不限制。并且受限于您开的并发数，为了您的上货速度,并没办法精准控制到您设置的数量，可能会超出一些。",
    },
    limit_goods_to_way: {
        label: "(微小店)上架上限后",
        key: "limit_goods_to_way",
        value: 2,
        options: [
            {
                value: 1,
                label: "不处理",
            },
            {
                value: 2,
                label: "上架到草稿箱",
            },
        ]
    },
    listing_way: {
        label: "上架方式",
        key: "listing_way",
        value: 2,
        options: [
            // {
            //     value: 1,
            //     label: "混合上接口",
            // },
            {
                value: 2,
                label: "官方API接口",
            },
            {
                value: 3,
                label: "本地接口",
            },
            {
                value: 4,
                label: "浏览器相似品发布",
            }
        ],
    },
    sync_publish_image_text: {
        label: "同步发布图文",
        key: "sync_publish_image_text",
        value: true,
        tip_step: "前往店铺后台 → 抖音账号管理 → 绑定抖音号",
        tip_benefit: "绑定成功后，每日发布商品，将自动发布图文获取海量曝光",
    },
    classification: {
        label: "类目设置",
        key: "classification",
        value: 1,
        options: [
            {
                value: 1,
                label: "自动匹配",
            },
            {
                value: 2,
                label: "手动匹配",
            },
        ],
        //当手动匹配时这个值是手动指定的分类id信息---抖店类目表读取类目信息 底下是格式
        // cid: 20005,
        // c_name: "半身裙",
        // c_path: ["女装", "半身裙"],
        // idpath_v2: "[20005],[20219]",
        // idpath: [20005, 20219],
        sub_value: {},
    },
    brand_setting: {
        label: "品牌设置",
        key: "brand_setting",
        value: 1,
        options: [
            {
                value: 1,
                label: "无品牌",
            },
            {
                value: 2,
                label: "软件自动对应",
            },
            {
                value: 3,
                label: "指定品牌",
            },
        ],
        sub_value: "", //当value=3时,此值为指定的品牌名称
        selectShop: "",
        selectShopInfo: false,
    },
    no_matched_with_attributes: {
        label: "没有匹配到属性的商品",
        key: "no_matched_with_attributes",
        value: 2,
        options: [
            {
                value: 1,
                label: "置为空，手动编辑后上传",
            },
            {
                value: 2,
                label: "自动匹配(保证成功率，但会出现性不正确问题)",
            },
        ],
    },
    delivery_time: {
        label: "现货发货时间",
        key: "delivery_time",
        model: 1,   //1现货先发模式 2现货+预售发貨模式
        model_options: [
            {
                value: 1,
                label: "现货先发模式",
            },
            // {
            //     value: 2,
            //     label: "现货+预售发貨模式",
            // },
            {
                value: 2,
                label: "全款预售发货模式(要店铺支持才能生效切记,否则设置了也无效)",
            },
            {
                value: 3,
                label: "现货+预售发货模式(要店铺支持才能生效切记,否则设置了也无效)",
            }
        ],
        value: 1,
        value3: [],
        day: '',
        options: [
            {
                value: 1,
                label: "48小时",
                model: 1,
            },
            {
                value: 2,
                label: "次日发",
                model: 1,
            },
            {
                value: 3,
                label: "当日发",
                model: 1,
            },
            {
                value: 4,
                label: "3天内发货",
                model: 1,
            },
            {
                value: 5,
                label: "4天内发货",
                model: 1,
            },
            {
                value: 6,
                label: "5天内发货",
                model: 1,
            },
            {
                value: 7,
                label: "6天内发货",
                model: 1,
            },
            {
                value: 8,
                label: "7天内发货",
                model: 1,
            },
            {
                value: 9,
                label: "8天内发货",
                model: 1,
            },
            {
                value: 10,
                label: "9天内发货",
                model: 1,
            },
            {
                value: 11,
                label: "10天内发货",
                model: 1,
            },
            {
                value: 12,
                label: "11天内发货",
                model: 1,
            },
            {
                value: 13,
                label: "12天内发货",
                model: 1,
            },
            {
                value: 14,
                label: "13天内发货",
                model: 1,
            },
            {
                value: 15,
                label: "14天内发货",
                model: 1,
            },
            {
                value: 16,
                label: "15天内发货",
                model: 1,
            },
            {
                value: 2,
                label: "次日发",
                model: 3,
            },
            {
                value: 1,
                label: "48小时内",
                model: 3,
            },
            {
                value: 4,
                label: "5天内",
                model: 3,
            },
            {
                value: 5,
                label: "7天内",
                model: 3,
            },
            {
                value: 6,
                label: "10天内",
                model: 3,
            },
            {
                value: 7,
                label: "15天内",
                model: 3,
            },
        ],
        options3: [
            {
                value: 1,
                label: "48小时内发货",
            },
            {
                value: 2,
                label: "5天内发货",
            },
            {
                value: 3,
                label: "7天内发货",
            },
            {
                value: 4,
                label: "10天内发货",
            },
            {
                value: 5,
                label: "15天内发货",
            },
        ],
    },
    deduction_inventory_type: {
        label: "扣减库存类型",
        key: "deduction_inventory_type",
        value: 1,
        options: [
            {
                value: 1,
                label: "拍下减库存",
            },
            {
                value: 2,
                label: "付款减库存",
            },
        ],
    },
    item_number: {
        label: "货号",
        key: "item_number",
        value: 1,
        options: [
            {
                value: 1,
                label: "不复制来源货号，留空",
            },
            {
                value: 2,
                label: "来源货号有则用，否则:留空",
            },
            {
                value: 3,
                label: "来源货号有则用，否则用:{来源ID}",
            },
            {
                value: 4,
                label: "来源货号有则用，否则用:{(平台首字母}#{来源ID}",
            },
            {
                value: 5,
                label: "统一用:{来源ID}",
            },
            {
                value: 6,
                label: "统一用:{平台首字母}#{来源ID}",
            },
            {
                value: 7,
                label: "随机货号 (降低重复铺货风险)",
            },
        ],
        pre: "",
        after: "",
    },
    sku_merchant_code: {
        label: "SKU商家编码",
        key: "sku_merchant_code",
        value: true,
        sub_value: 1,
        sub_options: [
            {
                value: 1,
                label: "商品ID",
            },
            {
                value: 2,
                label: "平台+商品ID",
            },
            {
                value: 3,
                label: "SKU名",
            },
        ],
        three_value: "-",
        three_options: [
            {
                value: "-",
                label: "中划线",
            },
            {
                value: "_",
                label: "下划线",
            },
            {
                value: "|",
                label: "竖线",
            },
            {
                value: " ",
                label: "空格",
            },
            {
                value: "",
                label: "无",
            },
        ],
    },
    inventory_settings: {
        label: "库存设置",
        key: "inventory_settings",
        value: 0, //统一库存为
        sub_value: 0, //如果来源SKU库存小于:0则将它设置为 0
        three_value: 0, //来源SKU库存为0时，将库存设置为:
    },
    sku_classification: {
        label: "SKU分类",
        key: "sku_classification",
        value: false, //软件自动分配
    },
    upload_sku_images: {
        label: "是否上传SKU图",
        key: "upload_sku_images",
        value: true, //上传
    },
    sku_image_is_missing: {
        label: "当SKU图空缺时",
        key: "sku_image_is_missing",
        value: 1,
        options: [
            {
                value: 1,
                label: "保持原状",
            },
            {
                value: 2,
                label: "补空白图",
            },
            {
                value: 3,
                label: "补第一张主图",
            },
        ],
    },
    sku_beyond_limit_del: {
        label: "当SKU超出时",
        key: "sku_beyond_limit_del",
        value: true,
        desc: "自动删除多余SKU",
    },
    customer_service_telephone: {
        label: "客服电话",
        key: "customer_service_telephone",
        value: "",
    },
    freight_template: {
        label: "运费模板",
        key: "freight_template",
        value: "", //模板名称
    },
    title_setting: {
        label: "标题设置",
        key: "title_setting",
        value: [],
        options: [
            {
                value: 1,
                label: "过滤英文",
            },
            {
                value: 2,
                label: "过滤数字",
            },
            {
                value: 3,
                label: "过滤空格",
            },
            {
                value: 4,
                label: "过滤括号及内容",
            },
            {
                value: 5,
                label: "智能生成短标题",
            },
        ],
        del_title_keyword: [],
        keyword_replace: [
            {
                search: "",
                replace: "",
            },
        ],
        pre: "",
        after: "",
        lock_pre_after: true, //锁定标题前后缀
        del_60: 2, //当标题超过60个字节，删除
        del_options: [
            //{
            //    value: 1,
            //    label: "最前面的字符",
            //},
            {
                value: 2,
                label: "最后面的字符",
            },
        ],
    },
    sku_alias_setting: {
        label: "SKU别名设置",
        key: "sku_alias_setting",
        del_keyword: [],
        keyword_replace: [
            {
                search: "",
                replace: "",
            },
        ],
        remove_keyword: [], //移除指定的sku名称
    },
    main_images_3_4: {
        label: "3:4主图",
        key: "main_images_3_4",
        value: false, //若上家有3:4主图时复制(目前只支持复制天猫、淘宝的3:4主图)
    },
    main_image_processing: {
        label: "主图处理",
        key: "main_image_processing",
        value: 1,
        options: [
            {
                value: 1,
                label: "制除主图前:0张 删除主图后: 0张",
            },
            {
                value: 2,
                label: "删除主图",
            },
            {
                value: 3,
                label: "随机打乱主图顺序",
            },
        ],
        first_image_lock: false, //当value=3时 首图不变位置
        pre: 0, //当value=1时 删除主图前:0张
        after: 0, //当value=1时 删除主图后: 0张
        del_image: [], //当value=2时 删除指定图片,第0张 第1张 第2张 第3张
        del_imgage_options: [
            { label: "第一张", value: 1 },
            { label: "第二张", value: 2 },
            { label: "第三张", value: 3 },
            { label: "第四张", value: 4 },
            { label: "第五张", value: 5 },
        ],
        use_low_sku_to_main_image: false, //使用最低价SKU作为第一张主图
    },
    main_image_supplement: {
        label: "主图补充",
        key: "main_image_supplement",
        value: 3, //主图数量少于3张自动补齐主图至
        options: [
            {
                value: 3,
                label: "3张",
            },
            {
                value: 4,
                label: "4张",
            },
            {
                value: 5,
                label: "5张",
            },
        ],
    },
    flip_the_main_image: {
        label: "主图翻转",
        key: "flip_the_main_image",
        value1: false, //主图1
        value2: false, //主图2
        value3: false, //主图3
        value4: false, //主图4
        value5: false, //主图5
    },
    main_image_watermark: {
        label: "主图水印",
        key: "main_image_watermark",
        value: false, //启用主图水印
        sub_value: false,   //启动3:4图水印
        use_image: [],
        use_image_options: [
            {
                value: 0,
                label: "主图1",
            },
            {
                value: 1,
                label: "主图2",
            },
            {
                value: 2,
                label: "主图3",
            },
            {
                value: 3,
                label: "主图4",
            },
            {
                value: 4,
                label: "主图5",
            },
            {
                value: 5,
                label: "全部SKU图",
            },
        ],
        sub_image: [],
        sub_image_options: [
            {
                value: 0,
                label: "3:4图1",
            },
            {
                value: 1,
                label: "3:4图2",
            },
            {
                value: 2,
                label: "3:4图3",
            },
            {
                value: 3,
                label: "3:4图4",
            },
            {
                value: 4,
                label: "3:4图5",
            }
        ],
        pos: 7,
        pos_options: [
            {
                value: 1,
                label: "右上",
            },
            {
                value: 2,
                label: "右中",
            },
            {
                value: 3,
                label: "右下",
            },
            {
                value: 4,
                label: "上中",
            },
            {
                value: 5,
                label: "正中",
            },
            {
                value: 6,
                label: "下中",
            },
            {
                value: 7,
                label: "左上",
            },
            {
                value: 8,
                label: "左中",
            },
            {
                value: 9,
                label: "左下",
            },
        ],
        keep: 2,
        keep_options: [
            {
                value: 1,
                label: "保留水印原始尺寸大小",
            },
            {
                value: 2,
                label: "自动调整水印尺寸至主图上",
            },
        ],
        /** 1=上传水印图(位置/大小) 2=易可图编辑水印 */
        watermark_mode: 2,
        watermark_mode_options: [
            { value: 1, label: "上传水印图" },
            { value: 2, label: "易可图编辑水印" },
        ],
        /** watermark_mode=2 时为 true，叠加时忽略 pos/keep */
        canvas_mode: true,
        water_mark_images: [],
        /** 与 water_mark_images[0] 对应，用于易可图海报编辑器恢复图层编辑状态 */
        water_mark_page_data: [],
        /** 易可图编辑原始素材图（logo 等），与导出后的 water_mark_images 区分 */
        water_mark_source_images: [],
        /** 3:4 专用水印（旧模板无此字段时后端回退主图水印） */
        sub_watermark_mode: 2,
        sub_watermark_mode_options: [
            { value: 1, label: "上传水印图" },
            { value: 2, label: "易可图编辑水印" },
        ],
        sub_canvas_mode: true,
        sub_water_mark_images: [],
        sub_water_mark_page_data: [],
        sub_water_mark_source_images: [],
    },
    main_image_1_1: {
        label: "主图1:1处理",
        key: "main_image_1_1",
        value: 1,
        options: [
            {
                value: 1,
                label: "补白",
            },
            {
                value: 2,
                label: "裁剪",
            },
        ],
    },
    describe_the_settings: {
        label: "描述设置",
        key: "describe_the_settings",
        value: 1,
        options: [
            //是否复制描述
            {
                value: 1,
                label: "是",
            },
            {
                value: 2,
                label: "使用商品主图",
            },
        ],
    },
    describe_the_image_settings: {
        label: "详情图设置",
        key: "describe_the_image_settings",
        value1: 0, //删除描述图前1张
        value2: 0, //删除描述图后1张
    },
    describe_the_to_main_image_settings: {
        label: "描述图没有时",
        key: "describe_the_to_main_image_settings",
        value: 1, //
        options: [
            //是否复制描述
            {
                value: 1,
                label: "随机用主图",
            },
            {
                value: 2,
                label: "保持原样",
            },
        ],
    },
    /** 复制描述且来源存在详情图时：用详情图上传 vs 仍用主图（与「使用商品主图」整段逻辑一致） */
    describe_has_detail_to_main_image_settings: {
        label: "详情图有时",
        key: "describe_has_detail_to_main_image_settings",
        value: 1,
        options: [
            {
                value: 1,
                label: "使用详情图",
            },
            {
                value: 2,
                label: "主图替换详情图(去掉原详情图，用主图去上)",
            },
        ],
    },
    add_description: {
        label: "添加描述图",
        key: "add_description",
        first: false, //首部添加描述图
        first_image: [],
        after: false, //尾部添加描述图
        after_image: [],
    },
    selling_price_setting: {
        label: "售卖价设置",
        key: "selling_price_setting",
        value: true, // 开启阶梯价
        data: [
            {
                start: 0, //元及以上时
                price_type: 1, //1.促销价 2.一口价
                multiplication: 1, //乘以
                add: 0, //加上
                subtraction: 0, //减去
                save: 1, //结果保留 1.保留分 2.保留角 3保留元
                fudong:false, //价格浮动区间启用和禁用
                addr1:0,//随机
                addr2:0,//随机
                ones_digit_enabled: false, //个位数金额
                ones_digit: 9,
                decimal_enabled: false, //小数处理
                decimal_value: 80,
            },
        ],
        options: [
            {
                label: "促销价",
                value: 1,
            },
            {
                label: "一口价",
                value: 2,
            },
        ],
        save_options: [
            {
                label: "保留分",
                value: 1,
            },
            {
                label: "保留角",
                value: 2,
            },
            {
                label: "保留元",
                value: 3,
            },
        ],
    },
    /** 1688：价格公式算完后再加运费。0关闭 1原样加 2运费×倍数；默认关闭 */
    add_1688_freight_to_sku: {
        label: "1688运费加价",
        key: "add_1688_freight_to_sku",
        value: 0,
        multiplication: 1,
        options: [
            {
                label: "关闭",
                value: 0,
            },
            {
                label: "把运费原样加到SKU商品价格上",
                value: 1,
            },
            {
                label: "把运费×倍数加到SKU商品价格上",
                value: 2,
            },
        ],
    },
    sku_low_price_hide: {
        label: "低价SKU隐藏",
        key: "sku_low_price_hide",
        avg_value: false, //未超过均价比例则下架，默认不勾选
        avg_percent: 30,
        avg_ques: "如，原商品sku价格=10,10,30,50。总和=100，均价=25，设置50%=12.5，则将①、②sku进行下架处理",
        max_value: false, //相对最高价过低则下架，默认不勾选
        max_percent: 300,
        max_ques: "如，原商品sku价格=9,10,20,30。设置300%：①9*3=27, ②10*3=30，都小于等于最高价30，将①、②进行下架处理",
        min_value: false, //唯一最低价则下架，默认不勾选
        min_ques: "多SKU且价格不完全相同时，只下架唯一的最低价SKU。最低价有多个并列，或全部同价，不处理。",
    },
    sku_low_price: {
        label: "SKU低价引流",
        key: "sku_low_price",
        value: false, //启用SKU低价引流方式
        sub_value: 1, //SKU低价引流方式
        options: [
            {
                label: "修改来源最低价SKU",
                value: 1,
            },
            {
                label: "增加低价引流SKU",
                value: 2,
            },
        ],
        third_value: 1,
        third_options: [
            {
                label: "计算后sku最低价",
                value: 1,
            },
            {
                label: "来源sku最低价",
                value: 2,
            },
        ],
        multiplication: 1, //倍数
        add: 0, //加上
        subtraction: 0, //减去
        stock: 100, //库存
        // 新增时的sku
        add_sku: {
            name: "",
            stock: 0, //库存
            images: [], // 单图也用数组
            target: 1, //1第一个规格, 2第二个规格
            position: "top", //sku位置 top 头部，bottom 尾部
        },
    },
    product_purchase_restriction: {
        label: "商品限购",
        key: "product_purchase_restriction",
        value1: 100, //每个用户累计限购 单位件
        value2: 100, //每次限购 单位件
    },
    support_7_day: {
        label: "是否支持7天无理由退换货",
        key: "support_7_day",
        value: true, //true支持 false不支持
        options: [
            {
                label: "支持",
                value: true,
            },
            {
                label: "不支持",
                value: false,
            },
        ],
    },
    after_sales_service_commitment: {
        label: "售后服务承诺",
        key: "after_sales_service_commitment",
        value: 1,
        options: [
            //售后服务承诺（对齐抖店三包：1不包含 / 3寄修 / 2延长；延长在部分类目已下线）
            {
                value: 1,
                label: "不包含",
            },
            {
                value: 3,
                label: "保修期内提供维修(寄修)",
            },
            {
                value: 2,
                label: "延长售后服务有效期",
            },
        ],
        // value=2/3 时使用；寄修常见从 90 天起，延长仍兼容 30/60
        sub_value: "90天",
        sub_options: [
            {
                label: "30天",
                value: "30天",
            },
            {
                label: "60天",
                value: "60天",
            },
            {
                label: "90天",
                value: "90天",
            },
            {
                label: "120天",
                value: "120天",
            },
            {
                label: "180天",
                value: "180天",
            },
            {
                label: "1年",
                value: "1年",
            },
            {
                label: "2年",
                value: "2年",
            },
            {
                label: "3年",
                value: "3年",
            },
            {
                label: "5年",
                value: "5年",
            },
        ],
    },
    shipping_insurance: {
        label: "运费险",
        key: "shipping_insurance",
        value: 1,
        options: [
            {
                value: 1,
                label: "关闭",
            },
            {
                value: 2,
                label: "开启",
            },
        ],
    },
    prohibited_words: {
        label: "违禁词",
        key: "prohibited_words",
        value: [], //1.自定义违禁词 2.系统违禁词
        words: [],
        options: [
            {
                label: "自定义违禁词",
                value: 1,
            },
            {
                label: "系统违禁词",
                value: 2,
            },
        ],
    },
    labeling: {
        label: "包装标签",
        key: "labeling",
        value: false, //是否自动生成包装标签图
    },
    production_license_diagram: {
        label: "生产许可证图",
        key: "production_license_diagram",
        value: false, //自动生成食品生产许可证图
    },
    skip_config: {
        label: "跳过配置",
        key: "skip_config",
        value: [1], //跳过配置；默认勾选已上架（开发环境 / kushang / deli 可取消，其它正式环境强制）
        options: [
            {
                label: "跳过已上架商品",
                value: 1,
            },
            {
                label: "跳过有品牌的商品",
                value: 2,
            },
            {
                label: "跳过海外/代购商品",
                value: 3,
            },
            {
                label: "跳过二手商品",
                value: 4,
            },
            {
                label: "跳过非全国包邮",
                value: 5,
            },
            {
                label: "跳过预售",
                value: 6,
            },
            {
                label: "跳过天猫超市",
                value: 7,
            },
            {
                label: "跳过已读取商品",
                value: 8,
            },
            {
                label: "跳过不包邮(只针对1688数据生效)",
                value: 9,
            },
             {
                label: "不含一件代发商品(只针对1688数据生效)",
                value: 10,
            },
        ],
        cate_value: [],
    },
    skip_price_exception: {
        label: "跳过价格异常",
        key: "skip_price_exception",
        value: false,
        desc: "跳过最低价SKU未超过SKU价格均值一半的商品",
        ques: `根据抖店规则，(sku总价/sku个数)/2=x(x是均值的意思)
若最低价sku价格<x，则符合未超过sku价格均值一半;`,
    },
    skip_sku_min_price: {
        label: "跳过SKU最低价格",
        key: "skip_sku_min_price",
        value: false,
        threshold: 0, // 跳过最低价SKU小于等于多少的商品
    },
    skip_main_image_count: {
        label: "跳过主图张数",
        key: "skip_main_image_count",
        value: false,
        threshold: 3, // 跳过主图张数小于多少的商品
    },
    only_copy_sku_price_range: {
        label: "仅复制该价格区间的商品",
        key: "only_copy_sku_price_range",
        value: false,
        min_price: 0,
        max_price: 99999,
    },
    skip_price_error: {
        label: "跳过错价",
        key: "skip_price_error",
        desc: "跳过错价的",
        value: true,
    },
    skip_smart_violation: {
        label: "智能跳过违规宝贝",
        key: "skip_smart_violation",
        desc: "智能跳过违规宝贝,此功能仅根据AI进行检测拦截，不作为抖店判定依据，建议上货完成后，人工检查一遍，避免带来不必要的损失!!!",
        value: false,
    },
    skip_invalid_goods: {
        label: "跳过无效商品",
        key: "skip_invalid_goods",
        desc: "跳过采购侧已标记为无效的商品，例如无货、下架无同款、不发货、质量差等，避免搬上无法采购的链接；命中后会提示对应原因。",
        value: false,
    },
    skip_sku_name: {
        label: "跳过SKU名称",
        key: "skip_sku_name",
        value: [],
    },
    skip_sku_price_diff: {
        label: "跳过SKU价格差异",
        key: "skip_sku_price_diff",
        value: [],
        options: [
            {
                label: "跳过最高价SKU大于最低价SKU x 倍的商品",
                value: 1,
            },
            {
                label: "跳过最高价SKU大于最低价SKU x 元的商品",
                value: 2,
            },
        ],
        multiplication: 1, //倍数
        yuan: 1, //元
    },
    skip_sku_price_same: {
        label: "跳过SKU价格一致",
        key: "skip_sku_price_same",
        desc: "过滤Sku价格一致的商品",
        value: false,
    },
    skip_sku_price_doudian_bei: {
        label: "跳过SKU价格倍数违规",
        key: "skip_sku_price_doudian_bei",
        value: false,
        desc: "跳过各SKU售卖价违反抖店类目倍数规则的商品(按类目+店铺记录的倍数判断,需先预测类目)",
    },
    skip_product_title_keyword: {
        label: "跳过商品标题关键词",
        key: "skip_product_title_keyword",
        value: [],
    },
    skip_season: {
        label: "跳过季节",
        key: "skip_season",
        value: [], //春1夏2秋3冬4
        options: [
            {
                label: "春",
                value: 1,
            },
            {
                label: "夏",
                value: 2,
            },
            {
                label: "秋",
                value: 3,
            },
            {
                label: "冬",
                value: 4,
            },
        ],
    },
    skip_bank_keyword: {
        label: "跳过品牌关键词",
        key: "skip_bank_keyword",
        value: [],
    },
    skip_product_id: {
        label: "跳过宝贝ID",
        key: "skip_product_id",
        value: [],
    },
    skip_cid: {
        label: "跳过指定类目",
        key: "skip_cid",
        value: [],
    },
    /** 跳过有售后预留金的商品：按抖店「售后预留金」冻结规则类目 */
    skip_after_sale_reserve: {
        label: "跳过有售后预留金的商品",
        key: "skip_after_sale_reserve",
        value: false,
        cids: [],
    },
    /** 跳过体验金高的商品：特殊类目基础保证金 + 体验保证金类目 */
    skip_high_experience: {
        label: "跳过体验金高的商品",
        key: "skip_high_experience",
        value: false,
        cids: [],
    },
    skip_total_stock: {
        label: "跳过总库存",
        key: "skip_total_stock",
        value: 0, // 跳过总库存小于多少的商品
    },
    skip_sales: {
        label: "跳过销量",
        key: "skip_sales",
        value: 0, // 跳过销量小于多少的商品
    },
    skip_price: {
        label: "跳过价格",
        key: "skip_price",
        value: 0, // 跳过价格小于等于多少的商品
        sub_value: 0, //  跳过价格大于等于多少的商品
    },
    skip_delivery_time: {
        label: "跳过发货时间",
        key: "skip_delivery_time",
        value: "", // 跳过发货时间大于等于多少的商品
        options: [
            {
                label: "24小时发货",
                value: 1,
            },
            {
                label: "48小时发货",
                value: 2,
            },
            {
                label: "72小时发货",
                value: 3,
            },
            {
                label: "4天内",
                value: 4,
            },
            {
                label: "5天内",
                value: 5,
            },
        ],
    },
    food_production_license_image: {
        label: "食品生产许可证照片",
        key: "food_production_license_image",
        value: [], //图片地址
    },
    package_label_image: {
        label: "包装标签",
        key: "package_label_image",
        value: [], //图片地址
    },
    ccc_certificate_image: {
        label: "CCC证书照片",
        key: "ccc_certificate_image",
        value: [], //图片地址
    },
    ph_certificate_image: {
        label: "国产普化备案电子凭证",
        key: "ph_record_voucher_image",
        value: [], //图片地址
    },
    gc_certificate_image: {
        label: "国产特化行政许可批件",
        key: "gc_certificate_image",
        value: [], //图片地址
    },
    copyright_page_image: {
        label: "版权页图",
        key: "copyright_page_image",
        value: [], //图片地址
    },
    jk_certificate_image: {
        label: "进口特化行政许可批件",
        key: "jk_certificate_image",
        value: [], //图片地址
    },
    customs_declaration: {
        label: "报关单",
        key: "customs_declaration",
        value: [], //图片地址
    },
    medical_device_registration_certificate: {
        label: "医疗器械注册证",
        key: "medical_device_registration_certificate",
        value: [], //图片地址
    },
    quality_inspection_report: {
        label: "质检报告",
        key: "quality_inspection_report",
        value: [], //图片地址
    },
    wash_label_image: {
        label: "水洗标",
        key: "wash_label_image",
        value: [], //图片地址
    },
    preset_properties: {
        label: "预置属性",
        key: "preset_properties",
        date_check: false, //生产日期勾选
        date_value: [0, 0], //生产日期
        fabric_check: false, // 面料勾选
        fabric_value: [
            //面料材质
            {
                name: "其他", //材质名称
                value: 100, //材质值 单位%
            },
        ],
        fabric_force: false, //面料强制勾选
        dy_value: [
            //抖音属性
            {
                check: false,
                name: "", //属性名
                value: "", //属性值
                type: 1, //抖音属性选择方式 1:强制启用 2:应用到未匹配
            },
        ],
        dy_options: [
            {
                label: "强制启用",
                value: 1,
            },
            {
                label: "应用到未匹配",
                value: 2,
            },
        ],
    },
};

export default CONFIG;
